module.exports = __webpack_public_path__ + "static/media/0_2018_12_30.8b992876.jpg";